import { cn, linkVariants } from '@seen/ui'
import type { AnchorHTMLAttributes } from 'react'
import { forwardRef } from '#src/utils/forwardRef.ts'

export type ExternalTextLinkProps = AnchorHTMLAttributes<HTMLAnchorElement>

export const ExternalTextLink = forwardRef<
  HTMLAnchorElement,
  ExternalTextLinkProps
>(({ className, children, ...delegated }, ref) => (
  <a
    ref={ref}
    target="_blank"
    rel="noreferrer"
    className={cn(linkVariants(), 'inline-flex items-baseline', className)}
    {...delegated}
  >
    {children}
  </a>
))
